<script>
export default {
  page: {
    title: 'Journal',
    meta: [{ name: 'description', content: 'The Journal page.' }],
  },
}
</script>

<template>
  <v-container :class="$style.pageContainer" fluid>
    <div :class="$style.paper">
      <img
        :class="$style.image"
        :src="require('@assets/images/safehaven/Journal.svg')"
      />

      <h4 class="mt-3 font-weight-bold">Journal</h4>

      <p :class="$style.description">
        Keeping a health journal promotes a holistic approach to your health by
        encouraging self-awareness. Daily journal entries can track your
        physical and emotional patterns, helping to identify triggers and
        patterns in health conditions or moods. It can also assist your
        healthcare professional in understanding symptoms, potential triggers,
        and treatment effectiveness.

        <br />
        <br />

        <span :class="$style.coming">Coming Soon</span>
      </p>
    </div>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.paper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 485px;
  padding: 30px 20px;
  margin: auto;
  margin-top: 64px;
  background-color: white;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}

.image {
  width: 180px;
}

.description {
  font-size: 14px;
}

.coming {
  font-weight: bold;
  color: #84b25a;
}
</style>
